var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"500","title":"500","sub-title":"很抱歉，服务器报告了一个错误。"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.toHome}},[_vm._v(" 返回首页 ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }